import { Suspense } from 'react'
import { UtmCookiesAndNavigationEvents } from './UtmCookiesAndNavigationEvents.client'

/**
 * Metrics and tracking code for /app layouts. Uses server-side rendering for
 * inserting the javascript trackers onto the page. Forces client-side rendering
 * behind suspense boundaries for navigation events and ensuring the url parameter
 * cookie is set correctly for attribution purposes.
 */
export default function UtmCookiesAndNavigationEventsForAppLayouts() {
  return (
    <Suspense fallback={null}>
      {/* Suspense boundary for client-side useEffect code */}
      <UtmCookiesAndNavigationEvents />
    </Suspense>
  )
}
